import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { endPoints } from "../../Constant/Environment";
import { useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { addItem } from "../../Utility/Api";
import { useNavigate } from "react-router-dom";
import Toaster from "../Toast/index";
import Loader from "../Loader/index";
import { ErrorToast, SuccesToast } from "../Toast/message";
import swal from 'sweetalert';
import { useModal } from '../../ModalContext';


function Login() {

  const { handleSecondModalClose,handleFirstModalClose,handleThirdModalOpen,handleSecondModalOpen} = useModal();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoadinig] = useState(false);
  const [isTravelerLoading, setIsTravelerLoadinig] = useState(false);
  const [travelerEmail, setTravelerEmail] = useState("");
  const [travelerPassword, setTravelerPassword] = useState("");
  const [travelerValidated, setTravelerValidated] = useState(false);

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const data = {
      username: email,
      password: password,
    };

    if (email && password) {
      try {
        const url = `${endPoints.api.UserLogin}`;
        setIsLoadinig(true);

        const response = await addItem(url, data);
        if (response.status === 200) {
          setTimeout(function () {
            localStorage.setItem("session", response.token);
            handleSecondModalClose();
            handleFirstModalClose();
            setIsLoadinig(false);
            dispatch({
              type: Actions.USERLOGIN,
              data: {
                user: response.final_data.users,
                travelerInfo: response.final_data.travelerInfoData,
                token: response.final_data.token,
                payment: response.final_data.payment,

              },
            });
            navigate("/dashboard");
          }, 1000);
        }
      } catch (error) {
        if (error.response.status === 401) {
          setIsLoadinig(false);
          ErrorToast(error.response.data.message);
        } else {
          ErrorToast(error);
        }

      }
    } else {
      setIsLoadinig(false);
      ErrorToast("All fields are required");
    }
  };

  return (
    <main className="bg-white">
      <section className="p-3 login-page">
        <div className="container">
          <h4 className="c-heading text-center">Login to your account</h4>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Toaster></Toaster>
        </div>
        <Row className="work-box rounded-0 border-0 ">
          <Tabs
            defaultActiveKey="first"
            className="align-items-center justify-content-center d-flex"
          >
            <Tab eventKey="first"  >
              <Row className="align-items-center justify-content-center mt-3">
                <Col md={10}>
                  <Form
                    validated={validated}
                    onSubmit={handleSubmit}
                    className="Reative"
                  >
                    {/* <Loader spinner={true} visible={true} className="LoaderForm" /> */}
                    {isLoading && (
                      <Loader
                        spinner={true}
                        visible={isLoading}
                        className="LoaderForm"
                      />
                    )}
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        type="text"
                        placeholder="Enter Email*"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Control
                        type="password"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Text
                      className="text-dark justify-content-end d-flex"
                    >
                      <span onClick={handleThirdModalOpen}>Forgot Password?</span>

                    </Form.Text>
                    <div className="justify-content-center d-flex">
                      <Button
                        to="/"
                        variant="primary"
                        type="submit"
                        className="log-btn"
                        onSubmit={handleSubmit}
                      >
                        Log In
                      </Button>
                    </div>
                    <Form.Text className="text-dark justify-content-center d-flex mt-4 fw-bold">
                      Dont have an account?
                      <span
                        className="loginf-sender"
                        onClick={handleSecondModalOpen}
                      >
                        Register Now
                      </span>
                    </Form.Text>
                  </Form>
                </Col>
              </Row>
            </Tab>

          </Tabs>
        </Row>
      </section>
    </main>
  );
}

export default Login;
